(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8336],{

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 99071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27812);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66261);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Index = function Index(_ref) {
  var links = _ref.links,
      listType = _ref.listType,
      columnGap = _ref.columnGap;

  // ナンバリングのスタート値を計算する
  var setStartValue = function setStartValue(index) {
    var count = 0;
    if (index === 0) return count;

    (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Array(index)).map(function (_, i) {
      return count += links[i].length;
    });

    return count;
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Wrapper, {
    columnGap: columnGap,
    children: links.map(function (arr, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(List, {
        startValue: setStartValue(index),
        listType: listType,
        as: listType === 'disc' ? 'ul' : '',
        children: arr.map(function (_ref2) {
          var name = _ref2.name,
              anchor = _ref2.anchor;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
            "data-list-type": listType,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU, {
              to: anchor,
              smooth: true,
              offset: -105,
              children: name
            })
          }, name);
        })
      }, "".concat(arr.toString()).concat(index));
    })
  });
};
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Index__Wrapper",
  componentId: "sc-12faqix-0"
})(["border:1px solid #707070;padding:30px 33px 25px;display:flex;column-gap:", "px;@media screen and (max-width:1047px){flex-direction:column;padding:30px 20px 27px;}"], function (_ref3) {
  var columnGap = _ref3.columnGap;
  return columnGap;
});
var ListStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["color:", ";counter-increment:number;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var List = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
  displayName: "Index__List",
  componentId: "sc-12faqix-1"
})(["letter-spacing:0.32px;counter-reset:", ";li{line-height:26px;letter-spacing:0.3px;&:hover{opacity:0.7;cursor:pointer;}&[data-list-type='number']::before{", ";content:counter(number) '. ';}&[data-list-type='roman']::before{", ";content:counter(number,upper-roman) '. ';}&[data-list-type='article']::before{", ";content:'\u7B2C' counter(number) '\u6761';}&[data-list-type='disc']::before{content:'';width:6px;height:6px;border-radius:50%;background-color:", ";display:inline-block;margin-right:0.5em;transform:translateY(-50%);}}a{color:", ";}@media screen and (max-width:1047px){li{font-size:15px;}}"], function (_ref4) {
  var startValue = _ref4.startValue,
      listType = _ref4.listType;
  return listType !== 'disc' ? "number ".concat(startValue) : '';
}, ListStyle, ListStyle, ListStyle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 68339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$V": function() { return /* binding */ SectionDiv; },
/* harmony export */   "CK": function() { return /* binding */ StyledList; },
/* harmony export */   "JP": function() { return /* binding */ GridTable2; },
/* harmony export */   "Jn": function() { return /* binding */ GridRow; },
/* harmony export */   "R1": function() { return /* binding */ GridTable; },
/* harmony export */   "U5": function() { return /* binding */ SummaryDiv; },
/* harmony export */   "ZB": function() { return /* binding */ ZenkakuSpace; },
/* harmony export */   "_b": function() { return /* binding */ StyledListInGridRow; },
/* harmony export */   "eX": function() { return /* binding */ StyledH3; },
/* harmony export */   "oH": function() { return /* binding */ StyledListItem; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var StyledLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["color:", ";text-decoration:underline;"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var SummaryDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SummaryDiv",
  componentId: "sc-rdu7qb-0"
})(["text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;a{", "}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:0.3px;}"], function (_ref) {
  var color = _ref.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, StyledLink);
var H3Style = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["font-size:22px;color:", ";font-weight:bold;line-height:30px;letter-spacing:0.88px;@media screen and (max-width:1047px){font-size:15px;letter-spacing:0.6px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);
var StyledH3 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "TextStyle__StyledH3",
  componentId: "sc-rdu7qb-1"
})(["", ""], H3Style);
var SectionDiv = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__SectionDiv",
  componentId: "sc-rdu7qb-2"
})(["width:100%;display:flex;flex-direction:column;row-gap:24px;text-align:left;font-size:16px;color:", ";font-weight:400;line-height:26px;letter-spacing:0.32px;h3{", "}ul{li{max-width:", ";}}ol{padding-left:25px;list-style-type:decimal;}li{span{display:block;font-weight:bold;}}p{span{font-weight:bold;}}a{", "}@media screen and (max-width:1047px){row-gap:30px;font-size:14px;line-height:24px;letter-spacing:0.28px;ul{li{width:100%;}}}"], function (_ref2) {
  var color = _ref2.color;
  return color === undefined ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : color;
}, H3Style, function (_ref3) {
  var liWidth = _ref3.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, StyledLink);
var GridTable = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable",
  componentId: "sc-rdu7qb-3"
})(["width:100%;display:grid;grid-template-columns:25% 25% 25% 25%;grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;@media screen and (max-width:1047px){grid-template-columns:50% 50%;}"]); // カラムが６つのテーブル、テーブル内の文章が単語関係なく改行

var GridTable2 = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridTable2",
  componentId: "sc-rdu7qb-4"
})(["width:100%;display:grid;grid-template-columns:repeat(6,16.6666667%);grid-template-rows:auto;border-top:1px solid #707070;border-left:1px solid #707070;word-break:break-all;"]);
var GridRow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "TextStyle__GridRow",
  componentId: "sc-rdu7qb-5"
})(["width:100%;display:contents;border-bottom:1px solid #707070;div{border-bottom:1px solid #707070;border-right:1px solid #707070;padding:20px 20px;}@media screen and (max-width:1047px){margin:0px 20px;div{padding:16px 20px 18px;}}"]);
var StyledList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "TextStyle__StyledList",
  componentId: "sc-rdu7qb-6"
})(["counter-reset:number ", ";max-width:", ";margin-left:", ";@media screen and (max-width:1047px){width:100%;margin-left:0;padding-left:", ";}"], function (_ref4) {
  var startValue = _ref4.startValue;
  return startValue === undefined ? '' : startValue;
}, function (_ref5) {
  var liWidth = _ref5.liWidth;
  return liWidth === undefined ? '100%' : "".concat(liWidth, "px");
}, function (_ref6) {
  var marginLeft = _ref6.marginLeft;
  return marginLeft === undefined ? '0' : "".concat(marginLeft, "em");
}, function (_ref7) {
  var paddingLeft = _ref7.paddingLeft;
  return paddingLeft === undefined ? '0' : "".concat(paddingLeft, "em");
});
var StyledListInGridRow = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(StyledList).withConfig({
  displayName: "TextStyle__StyledListInGridRow",
  componentId: "sc-rdu7qb-7"
})(["padding-left:0.8em;"]);
var Article = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var BoldArticle = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:1.5em;text-indent:-2.5em;font-weight:bold;p{text-indent:0em;font-weight:400;}::before{counter-increment:number;content:'\uFF08' counter(number) '\uFF09';}"]);
var Disc = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["text-indent:-1em;::before{counter-increment:number;content:'\u30FB';}"]);
var Comment = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-3.5em;::before{counter-increment:number;content:'\uFF08\u6CE8' counter(number) '\uFF09';}@media screen and (max-width:1047px){text-indent:-0.5em;}"]);
var Number = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(["padding-left:0.5em;text-indent:-1.5em;::before{counter-increment:number;content:counter(number) '. ';}"]);
var StyledListItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "TextStyle__StyledListItem",
  componentId: "sc-rdu7qb-8"
})(["font-weight:400;", " ", ";", ";"], function (_ref8) {
  var listType = _ref8.listType;

  switch (listType) {
    case 'article':
      return Article;

    case 'disc':
      return Disc;

    case 'comment':
      return Comment;

    case 'boldArticle':
      return BoldArticle;

    case 'number':
      return Number;

    case undefined:
      break;
  }
}, function (_ref9) {
  var paddingLeft = _ref9.paddingLeft;
  return paddingLeft && "padding-left:".concat(paddingLeft, "em");
}, function (_ref10) {
  var textIndent = _ref10.textIndent;
  return textIndent && "text-indent:".concat(textIndent, "em");
});
var ZenkakuSpace = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "TextStyle__ZenkakuSpace",
  componentId: "sc-rdu7qb-9"
})(["padding-left:", ";"], function (_ref11) {
  var space = _ref11.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});

/***/ }),

/***/ 91146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ImagePolicyPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/pages/Legal/TextStyle.tsx
var TextStyle = __webpack_require__(68339);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Legal/ImagePolicy/ImageItems.tsx




var imgItems = [{
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C1\u6761\uFF08\u5229\u7528\u8A31\u8AFE\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5229\u7528\u8005\u306B\u5BFE\u3057\u3001\u672C\u898F\u7D04\u306B\u898F\u5B9A\u3059\u308B\u5229\u7528\u65B9\u6CD5\u30FB\u6761\u4EF6\u306E\u7BC4\u56F2\u306B\u304A\u3044\u3066\u3001\u672C\u753B\u50CF\u3092\u5229\u7528\u3059\u308B\u3053\u3068\u3092\u975E\u5C02\u5C5E\u7684\u306B\u8A31\u8AFE\u3057\u307E\u3059\u3002"
    })]
  }),
  id: 'policy1'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C2\u6761\uFF08\u6A29\u5229\u306E\u5E30\u5C5E\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u306B\u95A2\u3059\u308B\u8457\u4F5C\u6A29\u53CA\u3073\u8457\u4F5C\u4EBA\u683C\u6A29\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u306F\u3001\u672C\u898F\u7D04\u306B\u898F\u5B9A\u3055\u308C\u308B\u6761\u4EF6\u306E\u3082\u3068\u3067\u5229\u7528\u8A31\u8AFE\u3059\u308B\u3082\u306E\u3067\u3042\u308A\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u5229\u7528\u8A31\u8AFE\u5F8C\u3082\u5F15\u304D\u7D9A\u304D\u672C\u753B\u50CF\u306E\u5229\u7528\u8A31\u8AFE\u6A29\u3092\u4FDD\u6301\u3057\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy2'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C3\u6761\uFF08\u5229\u7528\u6761\u4EF6\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u306F\u3001\u65B0\u805E\u30FB\u30C6\u30EC\u30D3\u30FB\u96D1\u8A8C\u30FB\u30AA\u30F3\u30E9\u30A4\u30F3\u30E1\u30C7\u30A3\u30A2\uFF08\u500B\u4EBA\u3067\u904B\u55B6\u3059\u308B\u3082\u306E\u3082\u542B\u307F\u307E\u3059\uFF09\u7B49\u306B\u304A\u3044\u3066\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u30C8\u30D4\u30C3\u30AF\u30B9\u3092\u7D39\u4ECB\u3059\u308B\u8A18\u4E8B\u3092\u4F5C\u6210\u3059\u308B\u969B\u306B\u5229\u7528\u3067\u304D\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u306F\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u305F\u5229\u7528\u8005\u672C\u4EBA\u306E\u307F\u304C\u5229\u7528\u3067\u304D\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u306F\u3001\u7B2C4\u6761\u306B\u8A18\u8F09\u3059\u308B\u5834\u5408\u3092\u9664\u304D\u3001\u52A0\u5DE5\u3057\u3066\u5229\u7528\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u672C\u753B\u50CF\u306B\u5BFE\u3057\u3066\u5229\u7528\u3092\u8A31\u8AFE\u3057\u306A\u3044\u6A29\u5229\u3092\u6709\u3057\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy3'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C4\u6761\uFF08\u7981\u6B62\u4E8B\u9805\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u55B6\u5229\u3001\u975E\u55B6\u5229\u3092\u554F\u308F\u305A\u672C\u753B\u50CF\u3092\u3001\u305D\u306E\u307E\u307E\u3001\u307E\u305F\u306F\u52A0\u5DE5\u3057\u3066\u3001\u72EC\u7ACB\u306E\u53D6\u5F15\u5BFE\u8C61\u3068\u3057\u3066\u3001\u9812\u5E03\uFF08\u8CA9\u58F2\u3001\u8CC3\u8CB8\u3001\u7121\u511F\u914D\u5E03\u3001\u7121\u511F\u8CB8\u4E0E\u306A\u3069\uFF09\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u904B\u55B6\u306E\u59A8\u3052\u306B\u306A\u308B\u3088\u3046\u306A\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u52A0\u5DE5\u306E\u6709\u7121\u3092\u554F\u308F\u305A\u672C\u753B\u50CF\u3092\u542B\u3080\u4E8C\u6B21\u7684\u8457\u4F5C\u7269\u3092\u4E3B\u8981\u30B3\u30F3\u30C6\u30F3\u30C4\u3068\u3057\u3066\u3001\u88FD\u54C1\u306B\u5229\u7528\u3059\u308B\u3053\u3068\u3001\u305D\u306E\u4ED6\u4E00\u5207\u306E\u4E8C\u6B21\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u52A0\u5DE5\u306E\u6709\u7121\u3092\u554F\u308F\u305A\u672C\u753B\u50CF\u3092\u7B2C\u4E09\u8005\u3078\u306E\u63D0\u4F9B\u30B5\u30FC\u30D3\u30B9\uFF08\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u306E\u30B0\u30EA\u30FC\u30C6\u30A3\u30F3\u30B0\u30AB\u30FC\u30C9\u30B5\u30FC\u30D3\u30B9\u3001\u30C6\u30F3\u30D7\u30EC\u30FC\u30C8\u306E\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u30B5\u30FC\u30D3\u30B9\u7B49\u3078\u306E\u5229\u7528\u3084\u3001\u643A\u5E2F\u96FB\u8A71\u306E\u5F85\u53D7\u753B\u9762\u3068\u3057\u3066\u306E\u5229\u7528\u3001\u30A2\u30D7\u30EA\u30B1\u30FC\u30B7\u30E7\u30F3\u30BD\u30D5\u30C8\u7B49\u306E\u7D20\u6750\u30B5\u30F3\u30D7\u30EB\u3068\u3057\u3066\u306E\u5229\u7528\u3001\u30B9\u30AF\u30EA\u30FC\u30F3\u30BB\u30FC\u30D0\u30FC\u3078\u306E\u5229\u7528\u7B49\u3092\u6307\u3057\u307E\u3059\u304C\u3001\u3053\u308C\u306B\u9650\u308A\u307E\u305B\u3093\uFF09\u306B\u7D44\u307F\u8FBC\u3093\u3067\u9812\u5E03\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u52A0\u5DE5\u306E\u6709\u7121\u3092\u554F\u308F\u305A\u5199\u771F\u3092\u7B2C\u4E09\u8005\u3078\u63D0\u4F9B\u3059\u308B\u76EE\u7684\u306E\u30D7\u30EA\u30F3\u30C8\u30B5\u30FC\u30D3\u30B9\u7B49\u3092\u884C\u3046\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u53D6\u5F15\u5148\u3078\u306E\u63D0\u4F9B\u304C\u76EE\u7684\u3067\u3042\u3063\u3066\u3082\u3001\u5229\u7528\u8005\u304C\u7B2C\u4E09\u8005\u306B\u672C\u753B\u50CF\u306E\u5229\u7528\u3092\u8A31\u8AFE\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u672C\u753B\u50CF\u3092\u7B2C\u4E09\u8005\u306B\u8B72\u6E21\u3001\u30EA\u30FC\u30B9\u3082\u3057\u304F\u306F\u8CB8\u4E0E\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u3092\u5546\u6A19\u3001\u5546\u53F7\u305D\u306E\u4ED6\u5546\u54C1\u7B49\u306E\u8868\u793A\u7B49\u306B\u5229\u7528\u3057\u3001\u767B\u8A18\u3001\u767B\u9332\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u3092\u4ED6\u306E\u30B9\u30C8\u30C3\u30AF\u30D5\u30A9\u30C8\u30B5\u30FC\u30D3\u30B9\u306B\u63D0\u4F9B\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u516C\u5E8F\u826F\u4FD7\u306B\u53CD\u3059\u308B\u65B9\u6CD5\u3067\u306E\u5229\u7528\u3001\u53C8\u306F\u516C\u5E8F\u826F\u4FD7\u306B\u53CD\u3059\u308B\u696D\u52D9\u30FB\u6D3B\u52D5\u306E\u7528\u306B\u4F9B\u3059\u308B\u76EE\u7684\u3067\u306E\u5229\u7528\u3001\u53CD\u793E\u4F1A\u7684\u306A\u614B\u69D8\u3067\u306E\u5229\u7528\u3001\u53CD\u793E\u4F1A\u7684\u306A\u696D\u52D9\u30FB\u6D3B\u52D5\u306B\u4F9B\u3059\u308B\u76EE\u7684\u3067\u306E\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u72AF\u7F6A\u7B49\u6CD5\u5F8B\u306B\u62B5\u89E6\u3059\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u5229\u7528\u305D\u306E\u4ED6\u9055\u6CD5\u3001\u865A\u507D\u3042\u308B\u3044\u306F\u8AB9\u8B17\u4E2D\u50B7\u3068\u306A\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u307E\u305F\u3001\u3053\u308C\u3089\u306E\u304A\u305D\u308C\u306E\u3042\u308B\u5185\u5BB9\u3092\u542B\u3080\u8A18\u4E8B\u3001\u6620\u50CF\u3001\u5BA3\u4F1D\u3001\u5E83\u544A\u7B49\u306B\u95A2\u3057\u3066\u672C\u753B\u50CF\u3092\u5229\u7528\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002\u672C\u753B\u50CF\u306B\u95A2\u3059\u308B\u8457\u4F5C\u6A29\u53CA\u3073\u8457\u4F5C\u4EBA\u683C\u6A29\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u5E30\u5C5E\u3057\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30A2\u30C0\u30EB\u30C8\uFF08R18\uFF09/\u98A8\u4FD7/\u6027\u7684\u63CF\u5199/\u5B97\u6559/\u9EBB\u85AC/\u30B9\u30C8\u30E9\u30A4\u30AD/\u30C7\u30E2/\u53CD\u767A\u56E3\u4F53/\u30C9\u30E9\u30C3\u30B0/\u30CA\u30A4\u30C8\u30B5\u30FC\u30D3\u30B9/\u51FA\u4F1A\u3044\u7CFB\u30B5\u30FC\u30D3\u30B9\uFF08\u5A5A\u6D3B/\u30DE\u30C3\u30C1\u30F3\u30B0/\u51FA\u5408\u3044\u7CFB\u60C5\u5831/\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u7570\u6027\u7D39\u4ECB\u4E8B\u696D\u5C4A\u51FA\u696D\u8005/\u305D\u306E\u4ED6\u3001\u51FA\u4F1A\u3044\u7CFB\u30B5\u30FC\u30D3\u30B9\u3068\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u5224\u65AD\u3059\u308B\u5834\u5408\uFF09\u7B49\u3067\u306E\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u54C1\u4F4D\u3001\u540D\u8A89\u307E\u305F\u306F\u4FE1\u7528\u3092\u5BB3\u3059\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u30A4\u30E1\u30FC\u30B8\u3092\u640D\u306A\u3046\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u3001\u305D\u306E\u4ED6\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u904B\u55B6\u306E\u59A8\u3052\u306B\u306A\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u3067\u306E\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u53CA\u3073\u672C\u753B\u50CF\u306E\u30E2\u30C7\u30EB\u306E\u54C1\u4F4D\u3001\u540D\u8A89\u307E\u305F\u306F\u4FE1\u7528\u3092\u5BB3\u3059\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u53CA\u3073\u30A4\u30E1\u30FC\u30B8\u3092\u640D\u306A\u3046\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u305D\u306E\u4ED6\u653B\u6483\u7684\u3001\u5DEE\u5225\u7684\u3001\u6027\u7684\u3001\u904E\u6FC0\u306A\u614B\u69D8\u3067\u306E\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u7B2C\u4E09\u8005\u306E\u540D\u8A89\u307E\u305F\u306F\u4FE1\u7528\u3092\u5BB3\u3059\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u53CA\u3073\u30A4\u30E1\u30FC\u30B8\u3092\u640D\u306A\u3046\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u305D\u306E\u4ED6\u7B2C\u4E09\u8005\u306B\u8FF7\u60D1\u3092\u304B\u3051\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u614B\u69D8\u3067\u306E\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u8457\u4F5C\u30FB\u5546\u6A19\u6A29\u7B49\u306E\u77E5\u7684\u8CA1\u7523\u6A29\u3001\u8CA1\u7523\u6A29\u3001\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u6A29\u3001\u30D1\u30D6\u30EA\u30B7\u30C6\u30A3\u6A29\u3001\u53C8\u306F\u8096\u50CF\u6A29\u306A\u3069\u306E\u6A29\u5229\u3092\u4FB5\u5BB3\u3059\u308B\u5229\u7528\u3001\u82E5\u3057\u304F\u306F\u6A29\u5229\u3092\u4FB5\u5BB3\u3059\u308B\u304A\u305D\u308C\u306E\u3042\u308B\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u3092\u306A\u308A\u3059\u307E\u3057\u3001\u305D\u306E\u4ED6\u865A\u507D\u306E\u60C5\u5831\u3068\u306A\u308A\u3048\u308B\u614B\u69D8\u3067\u306E\u5229\u7528\uFF08\u500B\u4EBA\u3084\u56E3\u4F53\u7B49\u306E\u7D39\u4ECB\u5199\u771F\u3001\u5546\u54C1\u3084\u88FD\u54C1\u7B49\u306E\u7D39\u4ECB\u5199\u771F\u3001\u5EFA\u7269\u3084\u65BD\u8A2D\u7B49\u306E\u7D39\u4ECB\u5199\u771F\u306A\u3069\u3092\u6307\u3057\u307E\u3059\u304C\u3001\u3053\u308C\u306B\u9650\u308A\u307E\u305B\u3093\uFF09\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u753B\u50CF\u306EURL\u3092\u76F4\u63A5\u547C\u3073\u51FA\u3057\u3066\u4ED6\u306E\u30DA\u30FC\u30B8\u306B\u8868\u793A\u3057\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306E\u30B5\u30FC\u30D0\u30FC\u306B\u8CA0\u62C5\u3092\u304B\u3051\u308B\u3088\u3046\u306A\u5229\u7528\u3092\u3059\u308B\u3053\u3068\u306F\u3067\u304D\u307E\u305B\u3093\u3002 \uFF0817\uFF09\u305D\u306E\u4ED6\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u304C\u4E0D\u9069\u5207\u3068\u5224\u65AD\u3059\u308B\u5229\u7528\u306F\u3067\u304D\u307E\u305B\u3093\u3002"
      })]
    })]
  }),
  id: 'policy4'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C5\u6761\uFF08\u514D\u8CAC\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u672C\u753B\u50CF\u306B\u5BFE\u3057\u3066\u3044\u304B\u306A\u308B\u4FDD\u8A3C\u3082\u884C\u3044\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u30C7\u30FC\u30BF\u306E\u6D88\u5931\u3001\u696D\u52D9\u306E\u4E2D\u65AD\u3001\u9038\u5931\u5229\u76CA\u3001\u7CBE\u795E\u7684\u640D\u5BB3\u7B49\u3092\u542B\u3081\u3001\u672C\u753B\u50CF\u306E\u5229\u7528\u307E\u305F\u306F\u5229\u7528\u4E0D\u80FD\u306B\u8D77\u56E0\u3059\u308B\u76F4\u63A5\u7684\u3001\u9593\u63A5\u7684\u3001\u7279\u5225\u3001\u5076\u767A\u7684\u3001\u7D50\u679C\u7684\u3001\u305D\u306E\u4ED6\u3044\u304B\u306A\u308B\u640D\u5BB3\u306B\u3082\u3001\u4E00\u5207\u306E\u8CAC\u4EFB\u3092\u8CA0\u3044\u307E\u305B\u3093\u3002"
      })]
    })]
  }),
  id: 'policy5'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C6\u6761\uFF08\u5229\u7528\u306E\u5DEE\u3057\u6B62\u3081\u7B49\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u5229\u7528\u8005\u304C\u672C\u898F\u7D04\u306E\u3044\u305A\u308C\u304B\u306E\u898F\u5B9A\u306B\u9055\u53CD\u3057\u305F\u5834\u5408\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u305F\u3060\u3061\u306B\u5229\u7528\u8005\u306B\u3088\u308B\u672C\u753B\u50CF\u306E\u5229\u7528\u3092\u5DEE\u6B62\u3081\u30FB\u672C\u753B\u50CF\u306E\u524A\u9664\u3092\u8ACB\u6C42\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u3001\u5229\u7528\u8005\u306F\u3001\u305F\u3060\u3061\u306B\u672C\u753B\u50CF\u304A\u3088\u3073\u305D\u306E\u8907\u88FD\u7269\u306E\u3059\u3079\u3066\u3092\u5EC3\u68C4\u3001\u62B9\u6D88\u307E\u305F\u306F\u524A\u9664\u3057\u306A\u3051\u308C\u3070\u306A\u308A\u307E\u305B\u3093\u3002"
    })]
  }),
  id: 'policy6'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C7\u6761\uFF08\u640D\u5BB3\u8CE0\u511F\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u5229\u7528\u8005\u304C\u672C\u898F\u7D04\u306B\u9055\u53CD\u3059\u308B\u884C\u70BA\u3092\u884C\u3063\u305F\u3053\u3068\u7B49\u306B\u3088\u308A\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u640D\u5BB3\u304C\u751F\u3058\u305F\u5834\u5408\u306B\u306F\u3001\u5229\u7528\u8005\u306F\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306B\u5BFE\u3057\u3066\u640D\u5BB3\u3092\u8CE0\u511F\u3059\u308B\u3082\u306E\u3068\u3057\u307E\u3059\u3002"
    })]
  }),
  id: 'policy7'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C8\u6761\uFF08\u898F\u7D04\u306E\u6539\u5B9A\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u3001\u672C\u898F\u7D04\u306E\u5168\u90E8\u3082\u3057\u304F\u306F\u4E00\u90E8\u3092\u4E88\u544A\u306A\u304F\u5909\u66F4\u3001\u8FFD\u52A0\u307E\u305F\u306F\u5EC3\u6B62\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u3053\u306E\u5834\u5408\u3001\u3053\u308C\u3089\u306E\u5909\u66F4\u3001\u8FFD\u52A0\u53C8\u306F\u5EC3\u6B62\u306B\u3088\u308B\u5229\u7528\u8005\u306E\u640D\u5BB3\u7B49\u306B\u3064\u3044\u3066\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\u306F\u4F55\u3089\u8CAC\u4EFB\u3092\u8CA0\u3046\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
    })]
  }),
  id: 'policy8'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
      children: "\u7B2C9\u6761\uFF08\u6E96\u62E0\u6CD5\u30FB\u5408\u610F\u7BA1\u8F44\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextStyle/* StyledList */.CK, {
      marginLeft: "0.5",
      paddingLeft: "0.5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u898F\u7D04\u306F\u65E5\u672C\u6CD5\u306B\u6E96\u62E0\u3057\u3001\u65E5\u672C\u6CD5\u306B\u5F93\u3063\u3066\u89E3\u91C8\u3055\u308C\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* StyledListItem */.oH, {
        listType: "article",
        children: "\u672C\u898F\u7D04\u306B\u95A2\u308F\u308B\u7D1B\u4E89\u304C\u767A\u751F\u3057\u305F\u5834\u5408\u306F\u3001\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u672C\u5E97\u6240\u5728\u5730\u3092\u7BA1\u8F44\u3059\u308B\u88C1\u5224\u6240\u3092\u5C02\u5C5E\u7684\u5408\u610F\u7BA1\u8F44\u88C1\u5224\u6240\u3068\u3057\u307E\u3059\u3002"
      })]
    })]
  }),
  id: 'policy9'
}, {
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["\u5236\u5B9A\u65E5", /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* ZenkakuSpace */.ZB, {}), "2022\u5E7412\u670826\u65E5"]
    })
  }),
  id: 'policy10'
}];
var imgLinks = [[{
  name: '（利用許諾）',
  anchor: 'policy1'
}, {
  name: '（権利の帰属）',
  anchor: 'policy2'
}, {
  name: '（利用条件）',
  anchor: 'policy3'
}], [{
  name: '（禁止事項）',
  anchor: 'policy4'
}, {
  name: '（免責）',
  anchor: 'policy5'
}, {
  name: '（利用の差し止め等）',
  anchor: 'policy6'
}], [{
  name: '（損害賠償）',
  anchor: 'policy7'
}, {
  name: '（規約の改定）',
  anchor: 'policy8'
}, {
  name: '（準拠法・合意管轄）',
  anchor: 'policy9'
}]];
// EXTERNAL MODULE: ./src/components/elements/LinkText/index.tsx
var LinkText = __webpack_require__(41705);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Legal/Index/index.tsx
var Index = __webpack_require__(99071);
;// CONCATENATED MODULE: ./src/components/pages/Legal/ImagePolicy/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var sectionTitle = {
  titleText: 'Image Policy',
  subTitleText: '画像規約'
};

var tSummary = /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
  children: ["\u3053\u306E\u753B\u50CF\u898F\u7D04\uFF08\u4EE5\u4E0B\u3001\u300C\u672C\u898F\u7D04\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u306F\u3001\u30C8\u30E9\u30A4\u30A2\u30EB\u30B0\u30EB\u30FC\u30D7\uFF08\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u53CA\u3073\u305D\u306E\u30B0\u30EB\u30FC\u30D7\u4F1A\u793E\u203B\u3092\u3044\u3044\u307E\u3059\uFF09\u304C\u3001\u30E1\u30C7\u30A3\u30A2\u5411\u3051\u8CC7\u6599\u3068\u3057\u3066\u516C\u958B\u3057\u3066\u3044\u308B\u753B\u50CF\uFF08\u4EE5\u4E0B\u3001\u300C\u672C\u753B\u50CF\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u306E\u53D6\u308A\u6271\u3044\u306B\u3064\u3044\u3066\u5B9A\u3081\u305F\u898F\u7D04\u3067\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u672C\u753B\u50CF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3055\u308C\u305F\u6642\u70B9\u3067\u3001\u672C\u753B\u50CF\u3092\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3057\u305F\u8005\uFF08\u4EE5\u4E0B\u3001\u300C\u5229\u7528\u8005\u300D\u3068\u3044\u3044\u307E\u3059\uFF09\u306F\u672C\u898F\u7D04\u306B\u540C\u610F\u3057\u305F\u3082\u306E\u3068\u307F\u306A\u3057\u307E\u3059\u3002", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u203B\u682A\u5F0F\u4F1A\u793E\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u30B0\u30EB\u30FC\u30D7\u4F1A\u793E\u306F", /*#__PURE__*/(0,jsx_runtime.jsx)(LinkText/* LinkText */.u, {
    path: "/company/overview/",
    text: "\u3053\u3061\u3089"
  }), "\u3067\u3059\u3002"]
});

var ImagePolicyPage = function ImagePolicyPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u753B\u50CF\u898F\u7D04",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u753B\u50CF\u898F\u7D04\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'legal/image-terms/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ImageContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CompleteTitle, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
          color: "normal",
          titleText: sectionTitle.titleText,
          subTitleText: sectionTitle.subTitleText
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 60
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SummaryDiv */.U5, {
        children: tSummary
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 35
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Index/* Index */.g, {
        columnGap: 46,
        listType: "article",
        links: imgLinks
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 70,
          sp: 40
        }
      }), imgItems.map(function (_ref, index) {
        var children = _ref.children,
            id = _ref.id;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextStyle/* SectionDiv */.$V, {
            id: id,
            children: children
          }), index < imgItems.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              pc: 70,
              sp: 39
            }
          })]
        }, "".concat(id).concat(index));
      })]
    })]
  });
};

ImagePolicyPage.getLayout = function (page) {
  var pageTitle = {
    title: 'Legal',
    subTitle: '法務'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '法務',
    path: '/legal/'
  }, {
    name: '画像規約',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: false,
    children: page
  }));
};

var ImageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ImagePolicy__ImageContainer",
  componentId: "sc-7oeogf-0"
})(["width:1040px;padding-top:62px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:40px 20px 68px;}"]);
var CompleteTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ImagePolicy__CompleteTitle",
  componentId: "sc-7oeogf-1"
})(["width:100%;margin:0 auto;@media screen and (max-width:1047px){max-width:200px;}"]);
;// CONCATENATED MODULE: ./src/pages/legal/image-terms.tsx


/***/ }),

/***/ 76750:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/image-terms",
      function () {
        return __webpack_require__(91146);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(76750); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);